<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span>Author’s Note</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal">Wow, what a wild ride this series has been. It all began with the Whispering Pines series and Ty’s lack of a Happily Ever After. I couldn’t have known when I decided to write <span style=" font-style: italic; font-size: 1.00em;">Riveted</span> (a free read for Ty &amp; Blake) that it would lead to yet another series, but I’m so glad it did. I fell in love with the scatterbrained Micah, wept for Mason, and cheered for Aiden. Tek &amp; Jamie? What can I say, other than I lurve them so hard. Thank you to all those who took this journey with me. I hope it was as rewarding to read as it was for me to write.</p>
<p class="P_Normal">~Hugs~</p>
<p class="P_Normal">Jo</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?29f9816c